// extracted by mini-css-extract-plugin
export default {"item":"MenuGroup_item__f08tC","container":"MenuGroup_container__ANdPl","selected":"MenuGroup_selected__JqTEv"};